import { Sun, Moon } from 'lucide-react';
import { useThemeMode } from '../contexts/ThemeContext';

const DarkModeToggle = ({ variant = 'header' }) => {
  const { mode, toggleTheme } = useThemeMode();

  const buttonClass = variant === 'sidebar'
    ? 'p-2 rounded-full text-slate-500 dark:text-slate-300 hover:text-slate-700 dark:hover:text-white hover:bg-slate-200/50 dark:hover:bg-white/10 transition-all duration-500 group outline-none'
    : 'p-2 rounded-full text-white/70 hover:text-white hover:bg-white/10 transition-all duration-500 group outline-none';

  return (
    <button
      onClick={toggleTheme}
      title={mode === 'light' ? 'Dark Mode' : 'Light Mode'}
      className={buttonClass}
    >
      <div className="transition-transform duration-500 group-hover:rotate-[180deg]">
        {mode === 'light' ? (
          <Moon size={22} className="fill-transparent" />
        ) : (
          <Sun size={22} className="fill-current text-yellow-400" />
        )}
      </div>
    </button>
  );
};

export default DarkModeToggle;
